import { render } from "./stickyScrollToButton.vue?vue&type=template&id=5d62d28f&scoped=true&ts=true"
import script from "./stickyScrollToButton.vue?vue&type=script&lang=ts"
export * from "./stickyScrollToButton.vue?vue&type=script&lang=ts"

import "./stickyScrollToButton.vue?vue&type=style&index=0&id=5d62d28f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d62d28f"]])

export default __exports__